import debounce from 'debounce';

export default class {

  constructor() {

    if (document.body.classList.contains('account')) {
      return;
    }

    this.items = document.getElementsByClassName('article_link');
    if (!this.items) {
      return;
    }

    this.main = document.getElementsByTagName('main')[0];
    this.offsetHeader = document.getElementById('header').offsetHeight + 32;
    this.updateOnLoad();

    this.onLoad();

    if (window.matchMedia('(max-width: 991px').matches) {
      this.horizontalScroll();
    }
    if (window.matchMedia('(min-width: 991px)').matches) {
      this.onScroll();
    }
  }

  isInViewport(element) {
    if (!element || element.style.display === 'none') {
      return false;
    }

    let bounding = element.getBoundingClientRect();
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  checkForText(tagName, text) {

    const callback = el => el.innerText === text;
    const el = Array.from(this.main.getElementsByTagName(tagName));
    return el.filter(callback);
  }

  getElementId(text) {

    let elementId = '';
    [...
      this.checkForText('h1', text),
      this.checkForText('h2', text),
      this.checkForText('h3', text),
      this.checkForText('h4', text),
      this.checkForText('h5', text),
      this.checkForText('h6', text)
    ].forEach((arr) => {
      [...arr].forEach((el) => {
        elementId = el.getAttribute('id');
      });
    });

    return elementId;
  }

  updateItems(text, id) {
    [...
      this.checkForText('h1', text),
      this.checkForText('h2', text),
      this.checkForText('h3', text),
      this.checkForText('h4', text),
      this.checkForText('h5', text),
      this.checkForText('h6', text)
    ].forEach((arr) => {
      [...arr].forEach((el) => {
        el.setAttribute('id', id);
      });
    });
  }

  /**
   * Events triggered on scroll; set active item based if in viewport & update url
   */
  onScroll() {
    let self = this;

    window.addEventListener('scroll', debounce(function () {
      let inViewPortArray = [];
      [...self.items].forEach((item) => {
        const element = document.getElementById(item.getAttribute('href').substring(1).trim());

        // Remove active class from all
        item.classList.remove('active');

        // Push true/false into array
        inViewPortArray.push(self.isInViewport(element));
      });

      // Loop through array and break on first `true`
      for (let i = 0, j = inViewPortArray.length; i < j; i++) {
        if (inViewPortArray[i] === true) {
          self.items[i].classList.add('active');
          history.pushState('', '', self.items[i].getAttribute('href'));
          break;
        }
      }
    }), 100);
  }

  /**
   * Update onload for set ID's on headings and update these by values from the article-menu
   */
  updateOnLoad() {
    [...this.items].forEach((item) => {
      const id = item.getAttribute('href').substring(1).trim();
      const element = document.getElementById(id);

      if (!element && document.documentElement.innerHTML.includes(item.innerText.trim())) {
       const elementId = this.getElementId(item.innerText.trim());
        if(elementId) {
          item.setAttribute('href', '#' + elementId);
          return;
        }

        this.updateItems(item.innerText.trim(), id);
      }
    });
  }

  /**
   * Scroll to the element which ID is in the permalink
   */
  onLoad() {

    if (!window.location.hash) {
      return;
    }

    for (let i = 0, j = this.items.length; i < j; i++) {
      this.items[i].classList.remove('active');

      if (window.location.hash === this.items[i].getAttribute('href')) {
        this.items[i].classList.add('active');
      }
    }

    const element = document.getElementById(window.location.hash.substring(1));

    if (!element) {
      // Probalby a wrong hash
      return;
    }

    window.scrollBy({
      top: element.getBoundingClientRect().y - this.offsetHeader,
      left: 0,
      behavior: 'smooth'
    });
  }

  horizontalScroll() {
    "use strict";

    const scrollBar = document.querySelector('.list-article_link');

    if (!scrollBar) {
      return;
    }
    let isDown = false,
      startX,
      scrollLeft;

    scrollBar.addEventListener('mousedown', (e) => {
      isDown = true;
      scrollBar.classList.add('active');
      startX = e.pageX - scrollBar.offsetLeft;
      scrollLeft = scrollBar.scrollLeft;
    });

    scrollBar.addEventListener('mouseleave mouseup', () => {
      isDown = false;
      scrollBar.classList.remove('active');
    });

    scrollBar.addEventListener('mousemove', (e) => {
      if (!isDown) {
        return;
      }

      e.preventDefault();
      const x = e.pageX - scrollBar.offsetLeft,
        walk = (x - startX) * 3;

      scrollBar.scrollLeft = scrollLeft - walk;
    });
  };
}
